import * as React from 'react';
import styled from 'styled-components';

import * as Theme from '../../serviceTheme';
import { withConfig } from '../utils';
import { InputColors, InputConfig } from '../Input';

declare module '../Controls/hkt' {
    interface URIControlsToKind {
        'textarea': Props
    }
}
type Props = {
    name: string,
    onChange: (value: string, name: string) => void,
    value?: string,
    className?: string,
    placeholder?: string,
    disabled?: boolean,
    rows?: number,
}

const Component = React.forwardRef<HTMLTextAreaElement, Props>(({ 
    name, 
    onChange, 
    value = '',
    className, 
    placeholder, 
    disabled,
    rows = 4,
}, ref) => {

    const [displayValue, updateValue] = React.useState(value);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;

        updateValue(value)
        onChange(value, name);
    }

    React.useEffect(() => {
        updateValue(value);
    }, [value]);

    return (
        <TextArea
            ref={ref}
            name={name}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
            className={className}
            rows={rows}
            value={displayValue}
        />
    );
});

export default Component;

const Textarea_ = styled.textarea`
    padding: .5em .7em;

    ${InputColors.rest}
    ${InputColors.normal}

    resize: vertical;

    &[value=""] {
        ${InputColors.emptyValue}
    }

    &:disabled {
        ${InputColors.disabled}

        &[value=""] {
            ${InputColors.disabledEmptyValue}
        }
    }

    &:focus {
        ${InputColors.focus}
    }

    &:not(:focus):not(:disabled):hover {
        ${InputColors.hover}

        &[value=""] {
            ${InputColors.hoverEmptyValue}
        }
    }

    &::placeholder {
        color: #898f9e;
    }

    &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
        padding: 1px;
    }

    &::-webkit-scrollbar-thumb {
        background: ${Theme.safeGetPrimary};
        border-radius: 40px 0px 0px 40px;
    }
`;


export const TextArea = withConfig<any, HTMLTextAreaElement>()(InputConfig)(Textarea_);
